import { combineReducers } from 'redux';
import authenticationReducer from './authenticationReducer';
import profileReducer from './profileReducer';
import chatsReducer from './chatsReducer';
import activeCallsReducer from './activeCallsReducer';
import oidcReducer from './oidcReducer';

export default (history) => {
    return combineReducers(
    {
        auth : authenticationReducer,
        profile : profileReducer,
        chats : chatsReducer,
        rtc : activeCallsReducer,
        oidcUser : oidcReducer
    });
}